/* istanbul ignore next */
export const imageViewDetailsTheme = ({
  palette: {
    primary: { normal }
  }
}) => ({
  textColor: normal
});

/* istanbul ignore next */
const styles = ({ imageViewDetails: { textColor }, palette: { grey }, spacing: { unit } }) => ({
  detailsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '80%',
    '@media (max-width: 800px)': {
      flexDirection: 'column',
      width: '100%'
    }
  },
  details: {
    minWidth: 100,
    flexGrow: 1,
    flexBasis: 0,
    padding: `0 ${unit * 4}px 0 0`,
    '& $title': {
      fontSize: 'inherit'
    },
    '@media (max-width: 800px)': {
      marginBottom: '15px'
    }
  },
  imageWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& button': {
      border: 'none',
      background: 'none',
      margin: `0 ${unit * 5}px`
    },
    '& svg': {
      color: grey.G400,
      height: unit * 7,
      width: unit * 7
    }
  },
  infoWrapper: {
    display: 'flex'
  },
  mobileDetailValue: {
    flex: 1,
    fontWeight: 'normal',
    textAlign: 'right'
  },
  mobileDetailsContainer: {
    display: 'flex'
  },
  title: {
    fontSize: unit * 2.25,
    fontWeight: 'bold'
  },
  titleWrapper: {
    padding: `0 ${unit * 3}px`,
    width: unit * 20
  },
  toggleButton: {
    color: textColor,
    padding: 0,
    border: 0,
    background: 'none'
  },
  wrapper: {
    marginTop: unit * 5,
    padding: unit * 3
  }
});

export default styles;
